import { render, staticRenderFns } from "./dt.vue?vue&type=template&id=5c2c880a&"
import script from "./dt.vue?vue&type=script&lang=js&"
export * from "./dt.vue?vue&type=script&lang=js&"
import style0 from "./dt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports